export default __webpack_public_path__ + "static/2.5.4/media/europeanFoundations.620a0de2.svg";